import appTheme from "../../../../theme/appTheme"

export const taskCardBGColor = appTheme.palette.eTypes.sand15
